<template>

    <div class="equipment-view-details">
        <b-card no-body>
            <b-card-header>
                <h5>Equipment Details</h5>
            </b-card-header>
            <b-card-body>
                <view-table :model="equipmentFields"
                            :data="equipment"
                            :fields="showFields"/>
            </b-card-body>
        </b-card>
    </div>

</template>

<script>
import Vue from 'vue'
import EquipmentFields from '@/models/Equipment'

export default Vue.extend({
    name: 'EquipmentViewDetails',
    props: {
        equipment: Object,
    },
    data () {
        return {
            equipmentFields: EquipmentFields,
            onRoadFields: [
                'company.name',
                'vehicle_id', // Vehicle ID
                'on_road',
                'type', //Type
                'fuel_type', // Fuel Type
                'license', // License
                'vin', // VIN
                'equipment_model_year', // Vehicle Model Year
                'equipment_manufacturer', // Vehicle Make
                'equipment_model', // Vehicle Model
                'engine_manufacturer', // Engine Manufacturer
                'engine_model', // Engine Model
                'engine_model_year', // Engine Model Year
                'engine_family_name', // Engine Family Name
                'engine_serial_number', // Engine Serial Number
                'engine_hp', // Engine Horsepower
                'exhaust_retrofit_type', // Exhaust Retrofit Type
                'retrofit_manufacturer.name', // Retrofit Manufacturer
                'retrofit_device.name', // Retrofit Model
                'retrofit_serial_number', // Retrofit Serial Number
                'retrofit_installation_year', // Retrofit Installation Year
                'notes', // Notes
                'updated',
                'attested',
                'registrationNumber',
            ],
            nonRoadFields: [
                'company.name',
                'vehicle_id', //Equipment ID
                'on_road',
                'type', //Type
                'fuel_type', // Fuel Type
                'equipment_manufacturer', // Equipment Manufacturer
                'equipment_model', // Equipment Model
                'equipment_serial_number', // Equipment Serial Number
                'engine_hp', // Engine Horsepower
                'engine_manufacturer', // Engine Manufacturer
                'engine_model', // Engine Model
                'engine_model_year', // Engine Model Year
                'engine_family_name', // Engine Family Name
                'engine_serial_number', // Engine Serial Number
                'exhaust_retrofit_type', // Exhaust Retrofit Type
                'retrofit_manufacturer.name', // Retrofit Manufacturer
                'retrofit_device.name', // Retrofit Model
                'retrofit_serial_number', // Retrofit Serial Number
                'retrofit_installation_year', // Retrofit Installation Year
                'notes', // Notes
                'updated',
                'attested',
                'registrationNumber',
            ]
        }
    },
    computed: {
        showFields () {
            return this.equipment.on_road ? this.onRoadFields : this.nonRoadFields
        }
    }
})
</script>
